import * as preact from "preact";
import { BaseComponent, IBaseComponentProps } from "../BaseComponent/BaseComponent";
import { RenderInBody } from "../RenderInBody/RenderInBody";


export interface IPopupProps extends IBaseComponentProps
{
    onClose?: Function;
    children: any;
    zeroContainer?: boolean;
}

export class Popup extends BaseComponent<IPopupProps>
{
    private static _position: number = 0;
    private static _overlay: HTMLElement; 
    private _isOpen: boolean;
    private _pnlContent: HTMLElement;

    public constructor(props: IPopupProps)
    {
        super(props);

        if (!Popup._overlay)
        {
            var overlay = document.createElement("div");
            overlay.className = "overlay";
            overlay.style.display = "none";
            document.body.appendChild(overlay);
            Popup._overlay = overlay;
        }
    }

    private _handleCancelClick(evt)
    {
        if (this.props.onClose)
        {
            this.props.onClose();
        }
        else
        {
            //make sure that SearchForm document click handler fires first
            setTimeout(()=> this.close());
        }

        evt.stopPropagation();
        evt.preventDefault();
    }

    public open()
    {
        if (this._isOpen)
        {
            return;
        }

        Popup._position++;
        var basePosition = this._calculateBaseZIndex(Popup._position);

        var overlay = Popup._overlay;
        overlay.style.zIndex = basePosition as any;
        overlay.style.display = "block";

        this.Container.style.zIndex = (basePosition + 1) as any;
        this.show();
        this._pnlContent.scroll(0, 0);
        this._isOpen = true;
    }

    public close()
    {
        if (!this._isOpen)
        {
            return;
        }

        Popup._position--;
        if (Popup._position < 1)
        {
            Popup._overlay.style.display = "none";
        }
        else
        {
            Popup._overlay.style.zIndex = this._calculateBaseZIndex(Popup._position) as any;
        }
        this._isOpen = false;
        this.hide();
    }

    public override componentDidMount()
    {
        document.body.appendChild(this.Container);
    }

    private _calculateBaseZIndex(position)
    {
        return 10 + (position * 3);
    }

    public render()
    {
        return (
            <RenderInBody>
                <div className={"popupContainer" + (this.props.zeroContainer? " zeroContainer": "")} ref={(ref) => this._registerContainer(ref)} style={{ display: "none" }}>
                    <div className="popup">
                        <div className="popupHeader">
                            <a href="javascript:void(0);" className="closeButton" onClick={this._handleCancelClick.bind(this)}>X</a>
                        </div>    

                        <div ref={(ref) => this._pnlContent = ref as any} className="popupContent">
                            {this.props.children}
                        </div>
                    </div>
                </div >
            </RenderInBody>);
    }
}